import React from 'react';
import { Switch } from 'react-router-dom';

/** IMPORT PAGES */
import EstoquePostoMonitor from '~/pages/EstoquePostoMonitor';
import EstoquePostoMonitorFullscreen from '~/pages/EstoquePostoMonitor/fullscreen';


import DlgRelLogAcesso from '~/pages/Relatorio/DlgRelLogAcesso';
import Usuarios from '~/pages/Cadastro/Usuarios';
import Padroes from '~/pages/Cadastro/Padroes';
import MsgtcaPosto from '~/pages/Operacao/MsgtcaPosto';
import VazaoEquipamentosBicos from '~/pages/Cadastro/VazaoEquipamentosBicos';
import ModeloEquipamento from '~/pages/Cadastro/ModeloEquipamento';
import Dashboard from '~/pages/Dashboard';
import Demo from '~/pages/Demo';
import TesteMousePosition from '~/pages/Teste/MousePosition';
import TesteCounter from '~/pages/Teste/Couter';
import DlgDescargaDetalhada from '~/pages/Relatorio/DlgRelDescargaDetalhada';

import DataPadrao from '~/pages/Teste/DataPadrao';

import DlgRelFormSub from '~/pages/Teste/DlgRelFormSub';

import TesteGeral from '~/pages/Teste/TesteGeral';

import TelaTransmiteCentral from '~/pages/Dashboard/components/TelaTransmiteCentral';

import DlgGraficoEvolucaoPostos from '~/pages/Relatorio/DlgGraficoEvolucaoPostos';

import DlgGraficoDescargaDifNF from '~/pages/Relatorio/DlgGraficoDescargaDifNF';

import DlgRelGraficoResTurno from '~/pages/Relatorio/DlgRelGraficoResTurno';

import DlgRelGraficoResTunoDia from '~/pages/Relatorio/DlgRelGraficoResTunoDia';

import DlgRelResumoPSDiesel from '~/pages/Relatorio/DlgRelResumoPSDiesel';
import DlgManutDadosDescarga from '~/pages/Manutencao/DlgManutDadosDescarga';
import DlgRelEstoque from '~/pages/Relatorio/DlgRelEstoque';
import TransVazAbast from '~/pages/Manutencao/TransVazAbast';
import DlgRelAbastecimento from '~/pages/Relatorio/DlgRelAbastecimento';
import DlgRelStatusOverFillAntesAbast from '~/pages/A2VF/DlgRelStatusOverFillAntesAbast';
import DlgRelVazao from '~/pages/Relatorio/DlgRelVazao';
import DlgRelTransmissao from '~/pages/Relatorio/DlgRelTransmissao';
import DlgRelResumoGeral from '~/pages/Relatorio/DlgRelResumoGeral';
import DlgRelResumoOperacao from '~/pages/Relatorio/DlgRelResumoOperacao';
import DlgRelVeiculo from '~/pages/Relatorio/DlgRelVeiculo';
import GraficoTanqueUnico from '~/pages/Relatorio/GraficoTanqueUnico';
import DlgRelMedicao from '~/pages/Relatorio/DlgRelMedicao';
import DlgRelPosto from '~/pages/Relatorio/DlgRelPosto';
import DlgRelDifEstoque from '~/pages/Relatorio/DlgRelDifEstoque';
import DlgRelDifEncerrante from '~/pages/Relatorio/DlgRelDifEncerrante';
import RelVtCertificados from '~/pages/Relatorio/RelVtCertificados';
import DlgRelDescargas from '~/pages/Relatorio/DlgRelDescargas';
import DlgRelVazaoNaoAutorizada from '~/pages/Relatorio/DlgRelVazaoNaoAutorizada';
import DlgRelAbastecimentocomA2vf from '~/pages/A2VF/DlgRelAbastecimentocomA2vf';
import DlgRelBatelada from '~/pages/Relatorio/DlgRelBatelada';
import DlgRelDreno from '~/pages/Relatorio/DlgRelDreno';
import DlgRelAfericao from '~/pages/Relatorio/DlgRelAfericao';
import ApuracaoInventario from '~/pages/Relatorio/ApuracaoInventario';
import DlgGraficoAbastecimento from '~/pages/Relatorio/DlgGraficoAbastecimento';
import DlgAbastecA2VFComp from '~/pages/A2VF/DlgAbastecA2VFComp';
import PostoVazao from '~/pages/Cadastro/PostoVazao';
import DlgRelResumoTurno from '~/pages/Relatorio/DlgRelResumoTurno';
import EstoqueProduto from '~/pages/Relatorio/EstoqueProduto';
import Equipamento from '~/pages/Cadastro/Equipamento';
import ConsultarCorrecoes from '~/pages/Manutencao/ConsultarCorrecoes';
import ExcluirVazamento from '~/pages/Manutencao/ExcluirVazamento';
import MensagensTCAGeral from '~/pages/Operacao/MensagensTCAGeral';
import PostoLocoMensagemTCA from '~/pages/Operacao/PostoLocoMensagemTCA';
import VeiculoMensagemTCA from '~/pages/Operacao/VeiculoMensagemTCA';
import NotFound from '~/pages/errors/NotFound';
import SignIn from '~/pages/SignIn';
import RetrasmitirUnilog from '~/pages/Manutencao/RetrasmitirUnilog';
import TrocarLocoAbast from '~/pages/Manutencao/TrocarLocoAbast';
import NotasFiscaisRecebidas from '~/pages/Relatorio/NotasFiscaisRecebidas';

import Route from './Route';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />

      <Route
        path="/dlgEstoquePostoMonitor"
        component={EstoquePostoMonitor}
        title="Estoque Monitor"
        isPrivate
        exact
      />


      <Route
        path="/dlgEstoquePostoMonitor_fullscreen"
        component={EstoquePostoMonitorFullscreen}
        title="Estoque Monitor"
        isPrivate
        fullScreen
        exact
      />


      {/* component={PostoVazao}
      title="Estoque Posto Monitor" */}

      <Route
        path="/dlgNotasFiscaisRecebidas"
        component={NotasFiscaisRecebidas}
        title="NF Recebidas"
        isPrivate
        exact
      />

      <Route
        path="/dlgManutDadosDescarga.swf"
        component={DlgManutDadosDescarga}
        title="Alterar Dados Descarga"
        isPrivate
        exact
      />

      <Route
        path="/Usuarios.swf"
        component={Usuarios}
        title="Usuários"
        isPrivate
        exact
      />

      <Route
        path="/dlgManutAltVazAbast.swf"
        component={TransVazAbast}
        title="Transformar Vazamento em Abastecimento"
        isPrivate
        exact
      />

      <Route
        path="/dlgRelStatusOverFillAntesAbast.swf"
        component={DlgRelStatusOverFillAntesAbast}
        title="Relatório Status Overfill Antes do Abastecimento"
        isPrivate
        exact
      />

      <Route
        path="/dlgGeralTodosMensagemTCA.swf"
        component={MensagensTCAGeral}
        title="Mensagens TCA Geral"
        isPrivate
        exact
      />

      <Route
        path="/dlgGeralMensagemTCA.swf"
        component={MsgtcaPosto}
        title="Mensagens Posto TCA"
        isPrivate
        exact
      />

      <Route
        path="/dlgVeiculoMensagemTCA.swf"
        component={VeiculoMensagemTCA}
        title="Equipamento Mensagem"
        isPrivate
        exact
      />

      <Route
        isPrivate
        exact
        path="/dlgPostoLocoMensagemTCA.swf"
        title="Equipamento Posto Mensagens"
        component={PostoLocoMensagemTCA}
      />

      <Route
        path="/PostoBicoEqptoVazao.swf"
        component={VazaoEquipamentosBicos}
        title="Vazão Equipamentos Bicos"
        isPrivate
        exact
      />

      <Route
        exact
        isPrivate
        path="/dlgAbastecA2VFComp.swf"
        component={DlgAbastecA2VFComp}
        title="Relatório Comparativo Abastecimentos A2VF"
      />

      <Route
        path="/ModeloVeiculo.swf"
        component={ModeloEquipamento}
        title="Modelo Equipamento"
        isPrivate
        exact
      />

      <Route path="/demo" component={Demo} title="Demonstração" isPrivate />

      <Route
        path="/dashboard"
        component={Dashboard}
        title="Dashboard"
        isPrivate
      />

      <Route
        isPrivate
        path="/PostoVazao.swf"
        component={PostoVazao}
        title="Cadastro Vazão Posto"
      />

      <Route
        isPrivate
        path="/dlgRelAbastecimentocomA2vf.swf"
        component={DlgRelAbastecimentocomA2vf}
        title="Relatório de Abastecimento com A2VF"
      />

      <Route
        isPrivate
        path="/dlgRelDescargas.swf"
        component={DlgRelDescargas}
        title="Relatório de recebimentos"
      />

      <Route
        isPrivate
        path="/dlgRelResumoGeral.swf"
        component={DlgRelResumoGeral}
        title="Relatório de Resumo Geral"
      />

      <Route
        isPrivate
        path="/dlgDescargaDetalhada.swf"
        component={DlgDescargaDetalhada}
        title="Relatório de Recebimentos"
      />

      <Route
        isPrivate
        path="/dlgRelResumoOperacao.swf"
        component={DlgRelResumoOperacao}
        title="Relatório de Resumo da Operação"
      />

      <Route
        isPrivate
        path="/dlgRelVeiculo.swf"
        component={DlgRelVeiculo}
        title="Relatório de Equipamentos"
      />

      <Route
        isPrivate
        path="/GraficoTanqueUnico.swf"
        component={GraficoTanqueUnico}
        title="Opções de Impressão"
      />

      <Route
        path="/MousePosition"
        component={TesteMousePosition}
        title="Teste Diversos"
        isPrivate
      />

      <Route
        path="/counter"
        component={TesteCounter}
        title="Teste counter"
        isPrivate
      />

      <Route
        path="/teste"
        component={TesteGeral}
        title="Teste TesteGeral"
        isPrivate
      />

      <Route
        path="/DataPadrao"
        component={DataPadrao}
        title="DataPadrao"
        isPrivate
      />

      <Route
        path="/dlgrelformsub"
        component={DlgRelFormSub}
        title="DlgRelFormSub"
        isPrivate
      />

      <Route
        path="/dlgRelDiagUnidata.swf"
        component={TelaTransmiteCentral}
        title="Transmissão Unidata"
        isPrivate
      />

      <Route
        path="/dlgGraficoEvolucaoPostos.swf"
        component={DlgGraficoEvolucaoPostos}
        title="Gráfico Evolução dos Postos"
        isPrivate
      />

      <Route
        path="/dlgGraficoDescargaDifNF.swf"
        component={DlgGraficoDescargaDifNF}
        title="Gráfico Evolução dos Postos"
        isPrivate
      />

      <Route
        path="/dlgRelGraficoResTurno.swf"
        component={DlgRelGraficoResTurno}
        title="Gráfico PS Turno"
        isPrivate
      />

      <Route
        path="/dlgRelGraficoResTunoDia.swf"
        component={DlgRelGraficoResTunoDia}
        title="Gráfico PS Dia"
        isPrivate
      />

      <Route
        path="/dlgRelResumoPSDiesel.swf"
        component={DlgRelResumoPSDiesel}
        title="Gráfico PS Diesel"
        isPrivate
      />

      <Route
        path="/dlgRelEstoque.swf"
        component={DlgRelEstoque}
        title="Relatório de Estoque"
        isPrivate
      />

      <Route
        path="/dlgRelAbastecimento.swf"
        component={DlgRelAbastecimento}
        title="Relatório Abastececimento"
        isPrivate
      />

      <Route
        path="/dlgRelTransmissao.swf"
        component={DlgRelTransmissao}
        title="Relatório de Transmissão"
        isPrivate
      />

      <Route
        path="/dlgRelVazaoNaoAutorizada.swf"
        component={DlgRelVazaoNaoAutorizada}
        title="Vazão não autorizada"
        isPrivate
      />

      <Route
        path="/dlgRelResumoTurno.swf"
        component={DlgRelResumoTurno}
        title="Resumo de Turno"
        isPrivate
      />

      <Route
        path="/monitoraTnqFisico.swf"
        component={EstoqueProduto}
        title="Estoque Tanques"
        isPrivate
      />

      <Route
        path="/dlgRelMedicao.swf"
        component={DlgRelMedicao}
        title="Medição Estoque"
        isPrivate
      />
      <Route
        path="/dlgRelVazao.swf"
        component={DlgRelVazao}
        title="RELATÓRIO DE VAZÃO"
        isPrivate
      />

      <Route
        path="/dlgRelPosto.swf"
        component={DlgRelPosto}
        title="Posto"
        isPrivate
      />

      <Route
        path="/dlgRelDifEstoque.swf"
        component={DlgRelDifEstoque}
        title="RELATÓRIO DE DIFERENÇA DE ESTOQUE"
        isPrivate
      />

      <Route
        path="/dlgRelDifEncerrante.swf"
        component={DlgRelDifEncerrante}
        title="RELATÓRIO DE DIFERENÇA DE ENCERRANTE"
        isPrivate
      />

      <Route
        path="/RelacaoVagoes.swf"
        component={RelVtCertificados}
        title="Relação De Vagões"
        isPrivate
      />

      <Route
        path="/dlgRelBatelada.swf"
        component={DlgRelBatelada}
        title="RELATÓRIO DE BATELADA"
        isPrivate
      />

      <Route
        path="/dlgRelDreno.swf"
        component={DlgRelDreno}
        title="RELATÓRIO DE DRENO"
        isPrivate
      />

      <Route
        path="/dlgRelAfericao.swf"
        component={DlgRelAfericao}
        title="RELATÓRIO DE AFERIÇÃO"
        isPrivate
      />

      <Route
        path="/ApuracaoInventario.swf"
        component={ApuracaoInventario}
        title="Apuração Inventário"
        isPrivate
      />

      <Route
        path="/dlgGraficoAbastecimento.swf"
        component={DlgGraficoAbastecimento}
        title="Abastecimento Grafic"
        isPrivate
      />

      <Route
        path="/Veiculos.swf"
        component={Equipamento}
        title="Equipamento"
        isPrivate
      />

      <Route
        path="/Padroes.swf"
        component={Padroes}
        title="Padrões"
        isPrivate
      />

      <Route
        path="/dlgManutAgenda.swf"
        component={ConsultarCorrecoes}
        title="Manutenção Agenda"
        isPrivate
      />

      <Route
        path="/dlgManutCancVazamento.swf"
        component={ExcluirVazamento}
        title="Excluir Vazamento"
        isPrivate
      />

      <Route
        path="/dlgRelLogAcesso.swf"
        component={DlgRelLogAcesso}
        title="Log Acesso"
        isPrivate
      />

      <Route
        path="/dlgManutEnviaLocoUnilog.swf"
        component={RetrasmitirUnilog}
        title="ENVIA EQUIPAMENTO PARA INTERFACE CLIENTE"
        isPrivate
      />

      <Route
        path="/dlgManutAltNumLoco.swf"
        component={TrocarLocoAbast}
        title="TROCAR EQUIPAMENTO DE UM ABASTECIMENTO"
        isPrivate
      />


      <Route path="*" component={NotFound} isPrivate />
    </Switch>
  );
}
